import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import VueLog from '@dreipol/vue-log';

import initVuex from 'framework/vuex';
import initRouter from 'framework/router';
import registry from './registry';
import vueLogConfig from './vue-log-config';
import '../../util/dom/cookie-monster-opener';


const CMS = window.CMS;
const isInCMS = Boolean(CMS);

/**
 * Create and mount a new component
 * @param {HTMLElement} node - The node
 * @param {object} options - Vue component extra options
 */
function mountComponent(node, { store, router }) {
    const name = node.getAttribute('is');
    const Component = new Vue({ name, store, router });

    Component.$mount(node);
}

/**
 * Bootstrap the vue root instance
 * @return {Promise} A promise returning when the registry has loaded all components and the app was initialized
 */
export function init() {
    // NOTE: Plugin initialisation is run before registry because new merge strategies might be applied by plugins.
    Vue.use(Vuex);
    Vue.use(VueRouter);
    Vue.use(VueLog, vueLogConfig);

    // if we are logged into the CMS we need to stop the vue warnings
    // the django-CMS will add dirty stuff into the DOM and vue doesn't like it
    Vue.config.silent = isInCMS;

    const store = initVuex();
    const router = initRouter();

    const mountAllComponentTags = () => {
        // If logged into the CMS we need to refresh the plugins after the vue rendering
        // this is needed to enable the frontend editing
        if (isInCMS) {
            requestAnimationFrame(() => {
                CMS.Plugin._refreshPlugins();
            });
        }

        // Instantiate all vue instances on this page
        const nodes = document.querySelectorAll('component[is]');
        Array.from(nodes).forEach(node => mountComponent(node, { store, router }));
    };
    const bootApp = () => registry({ router, store }).then(mountAllComponentTags);

    // remount the frontend components in case the cms will refresh their markup
    isInCMS && CMS.$(window).on('cms-content-refresh', bootApp);

    return bootApp();
}
